// extracted by mini-css-extract-plugin
export default {"wrap":"PH-z","fullWidth":"QH-z","hideOnDesktop":"RH-z","content":"SH-z","hasOpenedNav":"TH-z","crumbsList":"UH-z","dropdownsWrap":"VH-z"};